import _ from 'lodash';
import React from 'react';
import numeral from 'numeral';
import GenericSummary from '../GenericSummary';

const Summary = (props) => {
  const { quizState } = props;
  const { summary, product, content, sessionHistory } = quizState;

  const { correct, total } = summary;

  const summaryObj = sessionHistory.reduce((acc, historyItem) => {
    const { quizObj, isCorrect } = historyItem;
    const { item } = quizObj;
    const { contentUuid } = item;

    const groupValue = acc[contentUuid] || {
      correct: 0,
      total: 0,
    };

    if (isCorrect) {
      groupValue.correct += 1;
    }

    groupValue.total += 1;

    acc[contentUuid] = groupValue;
    return acc;
  }, {});

  const summaryLines = _.map(summaryObj, (value, key) => {
    const { name } = _.find(content || [], { uuid: key }) || { name: '(unknown)' };
    return {
      ...value,
      key,
      name,
    };
  });

  const score = numeral(correct / total).format('0%');

  return (
    <GenericSummary
      title="Review summary"
      product={product}
      summary={summaryLines}
      score={score}
    />
  );
};

export default Summary;
